import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <a href="https://play.google.com/store/apps/details?id=com.photoeditorsdk.android.app" target="_blank" rel="noopener nofollow noreferrer">
  example app
    </a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      